import { api } from "../api";

export const deleteTag = async (id: string): Promise<void> => {
  await api.services.tag.deleteTag(id);
};
